import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';
const { eSports } = enums;

export const mainContentId = 'right-content-container';
export const footballLikeSportsScore = [
  eSports.FOOTBALL,
  eSports.BASKETBALL,
  eSports.HANDBALL,
  eSports.ICE_HOCKEY,
  eSports.FUTSAL,
  eSports.DARTS
];
export const tennisLikeSportsScore = [
  eSports.TENNIS,
  eSports.BADMINTON,
  eSports.TABLE_TENNIS,
  eSports.VOLLEYBALL
];
export const sportsWithoutTimeDisplay = [
  eSports.TENNIS,
  eSports.BADMINTON,
  eSports.TABLE_TENNIS,
  eSports.VOLLEYBALL
];
export const WIDGET_API_UPDATE_APPEND = 'UPDATE_APPEND';
export const WIDGET_API_TYPE_COMBINATION = 'TYPE_COMBINATION';

export const API_TIMEOUT = 20 * 1000;
